import L from "leaflet";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import marker from "leaflet/dist/images/marker-icon.png";
import marker2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import { useState } from "react";

delete L.Icon.Default.prototype["_getIconUrl"];

L.Icon.Default.mergeOptions({
    iconRetinaUrl: marker2x,
    iconUrl: marker,
    shadowUrl: markerShadow,
});

const Map = ({ value, onChange }) => {
    const map = useMapEvents({
        click(e) {
            onChange({
                latitude: e.latlng.lat,
                longitude: e.latlng.lng,
                zoom: map.getZoom(),
            });
        },
        zoom(e) {
            onChange({
                latitude: value.latitude,
                longitude: value.longitude,
                zoom: map.getZoom(),
            });
        },
    });
    return (
        <>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
                position={[
                    value?.latitude || 35.685640118935986,
                    value?.longitude || 51.39129638671876,
                ]}
            ></Marker>
        </>
    );
};

export default function DBMap({ value, onChange }) {
    const [position] = useState([
        value?.latitude || 35.685640118935986,
        value?.longitude || 51.39129638671876,
    ]);
    return (
        <div className="db-map">
            <MapContainer
                center={position}
                zoom={value.zoom}
                scrollWheelZoom={false}
                style={{ height: 400 }}
            >
                <Map value={value} onChange={onChange} on />
            </MapContainer>
        </div>
    );
}
